(() => {

  'use strict';

 

  if (customElements.get('moshulu-plp-card')) return;

 

  const cardRequests = new WeakMap();

  const colourObservers = new WeakMap();

 

  function colourContainers(root) {

    const containers = Array.from(

      root.querySelectorAll('[data-plp-colours]')

    );

 

    if (root.matches?.('[data-plp-colours]')) {

      containers.unshift(root);

    }

 

    return containers;

  }

 

  let dialog;

  let dialogBody;

  let dialogRequest;

  let activeCard;

  let returnFocus;

  let returnScroll;

  let scrollRestoreFrame;

  let previousOverflow = '';

 

  function restoreCollectionScroll(position) {

    cancelAnimationFrame(scrollRestoreFrame);

 

    if (!position) return;

 

    const restore = () => {

      window.scrollTo(position.left, position.top);

    };

 

    // Restore immediately, then again after dialog and Reviews.io cleanup.

    restore();

 

    scrollRestoreFrame = requestAnimationFrame(() => {

      restore();

 

      scrollRestoreFrame = requestAnimationFrame(() => {

        restore();

        scrollRestoreFrame = null;

      });

    });

  }

 

  function updateColourArrows(container) {

    const row = container.querySelector('.plp-test-colour-row');

 

    if (!container.isConnected || !row || !container.clientWidth) return;

 

    const style = getComputedStyle(container);

    const availableWidth = container.clientWidth -

      (parseFloat(style.paddingLeft) || 0) -

      (parseFloat(style.paddingRight) || 0);

 

    // Measure against the space available with both arrows hidden.

    const needsArrows = row.scrollWidth > availableWidth + 1;

 

    container.querySelectorAll('[data-plp-scroll]').forEach(button => {

      if (button.hidden === needsArrows) {

        button.hidden = !needsArrows;

      }

    });

  }

 

  function initialiseColourRows(root) {

    colourContainers(root).forEach(container => {

      if (!container.isConnected) return;

 

      const row = container.querySelector('.plp-test-colour-row');

      if (!row) {

        disconnectColourRows(container);

        return;

      }

 

      updateColourArrows(container);

 

      if ('ResizeObserver' in window) {

        const previous = colourObservers.get(container);

 

        if (previous?.row === row) {

          return;

        }

 

        previous?.observer.disconnect();

        cancelAnimationFrame(previous?.frame);

 

        const state = { row, frame: null };

 

        state.observer = new ResizeObserver(() => {

          if (state.frame) return;

 

          state.frame = requestAnimationFrame(() => {

            state.frame = null;

            updateColourArrows(container);

          });

        });

 

        state.observer.observe(container);

        state.observer.observe(row);

 

        colourObservers.set(container, state);

      }

    });

  }

 

  function disconnectColourRows(root) {

    colourContainers(root).forEach(container => {

      const state = colourObservers.get(container);

      state?.observer.disconnect();

      cancelAnimationFrame(state?.frame);

      colourObservers.delete(container);

    });

  }

 

  function enableControls(root) {

    root.querySelectorAll('[data-plp-open]').forEach(button => {

      button.hidden = false;

    });

 

    initialiseColourRows(root);

  }

 

  class ProductCard extends HTMLElement {

    connectedCallback() {

      queueMicrotask(() => {

        if (this.isConnected) enableControls(this);

      });

 

      this.refreshControls();

    }

 

    refreshControls() {

      if (this._plpControlsFrame) return;

 

      this._plpControlsFrame = requestAnimationFrame(() => {

        this._plpControlsFrame = null;

        if (this.isConnected) enableControls(this);

      });

    }

 

    disconnectedCallback() {

      cancelAnimationFrame(this._plpControlsFrame);

      this._plpControlsFrame = null;

      cardRequests.get(this)?.abort();

      disconnectColourRows(this);

 

      if (activeCard === this && dialog?.open) {

        dialog.close();

      }

    }

  }

 

  customElements.define('moshulu-plp-card', ProductCard);

 

  async function fetchProduct(href, signal) {

    const url = new URL(href, location.origin);

 

    if (

      url.origin !== location.origin ||

      !url.pathname.includes('/products/')

    ) {

      throw new Error('Invalid product URL');

    }

 

    url.searchParams.set('view', 'plp-quick-view');

 

    const previewTheme = new URL(

      location.href

    ).searchParams.get('preview_theme_id');

 

    if (previewTheme) {

      url.searchParams.set('preview_theme_id', previewTheme);

    }

 

    const response = await fetch(url, {

      credentials: 'same-origin',

      cache: 'no-store',

      signal

    });

 

    if (!response.ok) {

      throw new Error('Product request failed');

    }

 

    const parsed = new DOMParser().parseFromString(

      await response.text(),

      'text/html'

    );

 

    const card = parsed.querySelector(

      '[data-plp-card-response] moshulu-plp-card'

    );

 

    const content = parsed.querySelector(

      'template[data-plp-dialog-response]'

    );

 

    if (

      !card ||

      !content ||

      !content.content.querySelector('[data-plp-dialog-product]')

    ) {

      throw new Error('Quick View response template is missing');

    }

 

    return { card, content };

  }

 

  function showFailure(root, href) {

    const status = root.querySelector('[data-plp-status]');

 

    if (!status) return;

 

    const link = document.createElement('a');

 

    link.href = href;

    link.textContent = 'View product details';

    link.className = 'plp-test-full-details';

 

    status.replaceChildren(

      document.createTextNode('Unable to load this product. '),

      link

    );

  }

 

  function refreshReviews(card) {

    if (typeof window.initReviewsIoSnippets === 'function') {

      requestAnimationFrame(() => {

        if (card.isConnected) {

          window.initReviewsIoSnippets();

        }

      });

    }

  }

 

  function renderDialogBadges(sourceCard) {

    const badges = sourceCard.querySelector('template[data-plp-badges]');

    const gallery = dialogBody.querySelector('[data-plp-gallery]');

 

    if (!badges || !gallery) return;

 

    const media = gallery.parentElement;

    const layer = document.createElement('div');

 

    media.style.position = 'relative';

    layer.setAttribute('data-plp-dialog-badges', '');

    layer.style.cssText =

      'position: absolute; inset: 0; z-index: 3; pointer-events: none;';

 

    layer.append(document.importNode(badges.content, true));

    media.prepend(layer);

  }

 

  function replaceCard(card, response, focusSwatch) {

    if (!card?.isConnected) return;

 

    const oldContent = card.querySelector('[data-product-card]');

    const newContent = response.card.querySelector(

      '[data-product-card]'

    );

 

    if (!oldContent || !newContent) {

      throw new Error('Product card is missing');

    }

 

    disconnectColourRows(card);

 

    oldContent.replaceChildren(

      ...document.importNode(newContent, true).childNodes

    );

 

    if (oldContent.hasAttribute('data-depict-product-id')) {

      oldContent.setAttribute(

        'data-depict-product-id',

        response.card.dataset.selectedProductId

      );

    }

 

    card.dataset.productUrl = response.card.dataset.productUrl;

    card.dataset.selectedProductId =

      response.card.dataset.selectedProductId;

 

    enableControls(card);

 

    const selected = card.querySelector(

      '[data-plp-colour][aria-current="true"]'

    );

 

    if (focusSwatch) {

      selected?.focus({ preventScroll: true });

    }

 

    const row = selected?.closest('.plp-test-colour-row');

 

    if (row && selected) {

      row.scrollLeft =

        selected.offsetLeft -

        row.offsetLeft -

        row.clientWidth / 2 +

        selected.clientWidth / 2;

    }

 

    refreshReviews(card);

  }

 

  async function changeCardColour(card, href) {

    cardRequests.get(card)?.abort();

 

    const request = new AbortController();

 

    cardRequests.set(card, request);

    card.setAttribute('aria-busy', 'true');

 

    const status = card.querySelector('[data-plp-status]');

 

    if (status) {

      status.textContent = 'Loading colour…';

    }

 

    try {

      const result = await fetchProduct(href, request.signal);

 

      if (

        request.signal.aborted ||

        cardRequests.get(card) !== request

      ) {

        return;

      }

 

      replaceCard(card, result, true);

 

      const updatedStatus = card.querySelector('[data-plp-status]');

 

      if (updatedStatus) {

        updatedStatus.textContent = '';

      }

    } catch (error) {

      if (error.name !== 'AbortError') {

        showFailure(card, href);

      }

    } finally {

      if (cardRequests.get(card) === request) {

        cardRequests.delete(card);

        card.removeAttribute('aria-busy');

      }

    }

  }

 

  function createDialog() {

    if (dialog) return;

 

    dialog = document.createElement('dialog');

    dialog.className = 'plp-test-dialog';

 

    dialog.setAttribute(

      'aria-labelledby',

      'plp-test-dialog-title'

    );

 

    dialog.innerHTML = `

      <div class="plp-test-dialog-header">

        <h2 id="plp-test-dialog-title">Quick View</h2>

        <button

          type="button"

          class="plp-test-close"

          data-plp-close

          aria-label="Close Quick View"

        >×</button>

      </div>

      <div data-plp-dialog-body></div>

    `;

 

    dialogBody = dialog.querySelector('[data-plp-dialog-body]');

 

    document.body.append(dialog);

 

    dialog.addEventListener('close', () => {

      dialogRequest?.abort();

 

      document.documentElement.style.overflow = previousOverflow;

 

      const scrollPosition = returnScroll;

      returnScroll = null;

 

      const focusTarget = returnFocus?.isConnected

        ? returnFocus

        : activeCard?.querySelector('[data-plp-open]');

 

      focusTarget?.focus({ preventScroll: true });

 

      restoreCollectionScroll(scrollPosition);

 

      activeCard = null;

      disconnectColourRows(dialogBody);

      dialogBody.replaceChildren();

    });

 

    dialog.addEventListener('click', event => {

      if (event.target !== dialog) return;

 

      const rect = dialog.getBoundingClientRect();

 

      if (

        event.clientX < rect.left ||

        event.clientX > rect.right ||

        event.clientY < rect.top ||

        event.clientY > rect.bottom

      ) {

        dialog.close();

      }

    });

  }

 

  async function loadDialog(href, colourChange = false) {

    dialogRequest?.abort();

 

    const request = new AbortController();

 

    dialogRequest = request;

    dialogBody.setAttribute('aria-busy', 'true');

 

    dialogBody.querySelectorAll(

      '[data-plp-variant], [data-plp-add]'

    ).forEach(control => {

      control.disabled = true;

    });

 

    if (!colourChange) {

      disconnectColourRows(dialogBody);

      dialogBody.innerHTML =

        '<p data-plp-status role="status">Loading product…</p>';

    }

 

    try {

      const result = await fetchProduct(href, request.signal);

 

      if (

        request.signal.aborted ||

        dialogRequest !== request ||

        !dialog.open

      ) {

        return;

      }

 

      disconnectColourRows(dialogBody);

 

      dialogBody.replaceChildren(

        document.importNode(result.content.content, true)

      );

 

      renderDialogBadges(result.card);

      enableControls(dialogBody);

 

      if (colourChange) {

        cardRequests.get(activeCard)?.abort();

 

        replaceCard(activeCard, result, false);

 

        dialogBody.querySelector(

          '[data-plp-colour][aria-current="true"]'

        )?.focus({ preventScroll: true });

      }

    } catch (error) {

      if (error.name !== 'AbortError') {

        showFailure(dialogBody, href);

 

        const select = dialogBody.querySelector(

          '[data-plp-variant]'

        );

 

        if (select) {

          select.disabled = false;

 

          const add = dialogBody.querySelector('[data-plp-add]');

 

          if (add) {

            add.disabled = !select.value;

          }

        }

      }

    } finally {

      if (dialogRequest === request) {

        dialogBody.removeAttribute('aria-busy');

      }

    }

  }

 

  function isNormalClick(event) {

    return (

      event.button === 0 &&

      !event.metaKey &&

      !event.ctrlKey &&

      !event.shiftKey &&

      !event.altKey

    );

  }

 

  document.addEventListener('click', event => {

    if (!(event.target instanceof Element)) return;

 

    const target = event.target;

    const card = target.closest('moshulu-plp-card');

    const inDialog = dialog?.open && dialog.contains(target);

 

    if (!card && !inDialog) return;

 

    const colour = target.closest('[data-plp-colour]');

 

    if (colour && isNormalClick(event)) {

      event.preventDefault();

      event.stopImmediatePropagation();

 

      if (colour.getAttribute('aria-current') === 'true') {

        return;

      }

 

      if (inDialog) {

        loadDialog(colour.href, true);

      } else {

        changeCardColour(card, colour.href);

      }

 

      return;

    }

 

    const open = target.closest('[data-plp-open]');

 

    if (open) {

Shopify.analytics.publish('quick_view_open', {

        product_url: card.dataset.productUrl,

        product_id: card.dataset.selectedProductId

      });

 

      event.preventDefault();

      event.stopImmediatePropagation();

 

      cardRequests.get(card)?.abort();

 

      createDialog();

 

      activeCard = card;

      returnFocus = open;

      returnScroll = {

        left: window.scrollX,

        top: window.scrollY

      };

      cancelAnimationFrame(scrollRestoreFrame);

      scrollRestoreFrame = null;

      previousOverflow = document.documentElement.style.overflow;

 

      dialog.showModal();

 

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({

        event: 'quick_view_open'

      });

 

      document.documentElement.style.overflow = 'hidden';

 

      loadDialog(card.dataset.productUrl);

 

      return;

    }

 

    if (target.closest('[data-plp-close]')) {

      event.preventDefault();

      event.stopImmediatePropagation();

 

      dialog.close();

 

      return;

    }

 

    const scroll = target.closest('[data-plp-scroll]');

    const galleryArrow = target.closest('[data-plp-image]');

 

    if (scroll || galleryArrow) {

      event.preventDefault();

      event.stopImmediatePropagation();

 

      const row = scroll

        ? scroll.closest('[data-plp-colours]')

          .querySelector('.plp-test-colour-row')

        : dialogBody.querySelector('[data-plp-gallery]');

 

      const direction = Number(

        scroll

          ? scroll.dataset.plpScroll

          : galleryArrow.dataset.plpImage

      );

 

      const reduceMotion = window.matchMedia(

        '(prefers-reduced-motion: reduce)'

      ).matches;

 

      row.scrollBy({

        left: direction * row.clientWidth,

        behavior: reduceMotion ? 'instant' : 'smooth'

      });

    }

  }, true);

 

  document.addEventListener('change', event => {

    const select = event.target;

 

    if (

      !(select instanceof HTMLSelectElement) ||

      !select.matches('[data-plp-variant]') ||

      !dialog?.contains(select)

    ) {

      return;

    }

 

    const option = select.selectedOptions[0];

    const add = dialogBody.querySelector('[data-plp-add]');

 

    if (add) {

      add.disabled = !option?.value || option.disabled;

    }

 

    const price = Array.from(

      dialogBody.querySelectorAll('template[data-plp-price-for]')

    ).find(item => item.dataset.plpPriceFor === select.value);

 

    if (price) {

      dialogBody.querySelector(

        '[data-plp-variant-price]'

      ).replaceChildren(

        document.importNode(price.content, true)

      );

    }

  });

 

  document.addEventListener('submit', event => {

    const form = event.target;

 

    if (

      !(form instanceof HTMLFormElement) ||

      !dialog?.contains(form) ||

      !form.matches('.plp-test-form')

    ) {

      return;

    }

 

    // The cart helper handles this event at window capture first.

    // If it has not loaded, keep the customer on this page.

    event.preventDefault();

    event.stopImmediatePropagation();

    const status = dialogBody.querySelector('[data-plp-status]');

    if (status) {

      status.textContent = 'The basket is still loading. Please try again.';

    }

  }, true);

 

  window.addEventListener('pageshow', event => {

    if (event.persisted && dialog?.open) {

      dialog.close();

    }

 

    refreshAllColourRows();

  });

 

  let colourRefreshFrame;

 

  function refreshAllColourRows() {

    if (colourRefreshFrame) return;

 

    colourRefreshFrame = requestAnimationFrame(() => {

      colourRefreshFrame = null;

      initialiseColourRows(document);

    });

  }

 

  window.addEventListener('resize', refreshAllColourRows);

  window.addEventListener('load', refreshAllColourRows);

  document.addEventListener('shopify:section:load', refreshAllColourRows);

 

  // Stylesheets can finish loading without changing the outer card width.

  document.addEventListener('load', event => {

    if (event.target instanceof HTMLLinkElement && event.target.rel === 'stylesheet') {

      refreshAllColourRows();

    }

  }, true);

 

  if (document.fonts) {

    document.fonts.ready.then(refreshAllColourRows);

    document.fonts.addEventListener('loadingdone', refreshAllColourRows);

  }

 

  refreshAllColourRows();

 

})();